import React, {useRef, useState} from 'react';
import {faCaretLeft, faCaretRight, faPlay} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import './Pager.css';

const Pager = (props) => {
    let { id, onPageClick, items, viewCount, controller, showSinglePage, dots, preDots, postDots } = props;
    let [currentPage, setCurrentPage] = useState(controller.page);
    
    if (!controller) {
        throw new Error("A pager controller is required to use the pager.");
        //return (<></>)
    }
    
    if (!items || !Array.isArray(items)) {
        return (<div className="pager" id={id}></div>);
    }

    if (typeof viewCount !== 'number' || viewCount === null) viewCount = 2;
    
    let pageViewCount = controller.pageViewCount;
    if (!pageViewCount || typeof pageViewCount !== 'number' || pageViewCount < 2) pageViewCount = 2;
    
    if (!id) id = 'pager-' + (new Date()).getTime().toString();
    
    const onPageChange = (pg, e) => {
        if (pg === currentPage) return;
        
        controller.setCurrentPage(pg);
        setCurrentPage(pg)

        if (typeof onPageClick === 'function' && onPageClick !== null) onPageClick(pg, e);
        else if (typeof controller.onPageClick === 'function' && controller.onPageClick !== null) controller.onPageClick(pg, e);
        else throw new Error('No onPageClick event was given (' + (typeof controller.onPageClick).toString() + '). Set the controller.onPageClick property or pass an onPageClick function to the pager.');
    };

    let pageSize = controller.pageSize;
    if (!pageSize || typeof pageSize !== 'number') pageSize = 20;
    
    // TODO: PageViewCount, PageViewRangeCount, etc
    let pageCount = Math.ceil(items.length / pageSize);
    if (pageCount < 2 && showSinglePage !== true) return (<></>);
    
    if (!dots) dots = (<>&bull;&bull;&bull;</>);
    else if (typeof dots === 'string') dots = (<>{dots}</>);
    
    let pageNumbers = [];
    let preView = preDots || dots;
    let postView = postDots || dots;
    
    for(let i = 0; i < pageCount; i++) {
        let c = i === currentPage ? ' selected' : '';
        let pg = (i + 1);
        
        let show = (currentPage < (i + viewCount + 1) && currentPage > (i - viewCount - 1)) ||
            (i < viewCount) || (i > pageCount - (viewCount + 1));

        if (show) {
            let pageElement = (
                <a className={'pager-item pager-item-' + i.toString() + c} onClick={onPageChange.bind(this, i)} key={i}>{ pg.formatNumber(0) }</a>
            );

            pageNumbers.push(pageElement);
        } else if (!!preView && i < currentPage) {
            pageNumbers.push(<span className="pager-item-pre-view" key={i}>{ preView }</span>);
            preView = "";
        } else if (!!postView && i > currentPage) {
            pageNumbers.push(<span className="pager-item-post-view" key={i}>{ postView }</span>);
            postView = "";
        } else {
            //pageNumbers.push((<b key={i}>.</b>));
        }
    }

    let prev = currentPage - 1;
    if (prev < 0) prev = 0;
    let next = currentPage + 1;
    
    if (next >= pageCount) next = pageCount - 1;
    
    return (
        
        <div className="pager" id={id}>
            <span>
                <a className={'pager-prev pager-arrow'} onClick={onPageChange.bind(this, prev)}><FontAwesomeIcon icon={faCaretLeft} /></a>
                { pageNumbers }
                <a className={'pager-next pager-arrow'} onClick={onPageChange.bind(this, next)}><FontAwesomeIcon icon={faCaretRight} /></a>
            </span>
            {props.children}
            <span></span>
        </div>
    );
};

export default Pager;
